import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  records: [],
  selected: null,
};

export const layoutSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    setRecords: (state, action) => {
      state.records = action.payload;
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setSelectedFinished: (state, action) => {
      state.selected.finished = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setRecords, setSelected, setSelectedFinished } = layoutSlice.actions;

export default layoutSlice.reducer;
